import {
  Component,
  OnInit,
  Inject,
  OnDestroy,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  Renderer2
} from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { trackEntityById, API_URL } from 'projects/core/src/public-api';
import { timer, forkJoin, Subject } from 'rxjs';
import { QBService } from '../../data/qb.service';
import { CustomerService } from '../../../customer/data/customer.service';
import { QbCustomer } from '../../../customer/data/qb-customer';
import { ProjectSales } from '../../data/project-sales';
import { ProjectSale } from '../../data/project-sale';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Project } from '../../../project-misc/data/project/project';
import { environment } from 'projects/desktop/src/environments/environment';
import {
  QbCustomerLinkDialogComponent
} from 'projects/desktop/src/app/modules/customer/view/customers-list/qb-customer-link-dialog/qb-customer-link-dialog.component';
import { Customer } from '../../../customer/data/customer';
import moment from 'moment';
import { map } from 'rxjs/operators';
import { QBServ } from '../../data/qb-serv';
import { QBClass } from '../../data/qb-class';
import { SelectItem } from 'primeng/api';
import { HttpClient } from '@angular/common/http';
import { QBFile } from '../../data/qb-file';
import { CreateEstiinvDialogComponent } from '../create-estiinv-dialog/create-estiinv-dialog.component';
import { ProjectService } from '../../../project-misc/data/project/project.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { PdfPreviewDialogComponent } from '../../../project-misc/view/pdf-preview-dialog/pdf-preview-dialog.component';
import jQuery from 'jquery';
import { takeUntil } from 'rxjs/operators';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import { MiscSnackBarService } from 'projects/core/src/lib/misc/view/snackbar/misc-snackbar.service';


@Component({
  selector: 'app-estimate-dialog',
  templateUrl: './estimate-dialog.component.html',
  styleUrls: ['./estimate-dialog.component.scss'],
  providers: [DeviceDetectorService]
})
@RxJSUnsubscribe
export class EstimateDialogComponent implements OnInit, OnDestroy, RxJSUnsubscribable {
  activeIndex: number[] = [];

  contentLoading = true;

  project: Project;
  projectId: number;
  projectName: string;
  customer: Customer;

  trackEntityById = trackEntityById;

  projectSales: ProjectSales = {};
  listToShow: ProjectSale[] = [];
  copyList: ProjectSale[];

  payments: ProjectSale[];
  paymentsMap = new Map<string, ProjectSale>();

  qbCustomers: QbCustomer[];

  sortMap = new Map();

  estloadingSpinner: boolean;
  loadingSpinner: boolean;

  qbConnected: boolean;

  totalOpenedBalance = 0;
  overdueOpenedBalance = 0;

  qbServClasses = [];

  baseQbServClasses = [];

  showPdfFile = false;
  pdfLoading = false;

  fileLoading$: Subject<string> = new Subject<string>();

  blobUrl: any;

  pdfHeader: string;

  showEstimateButton = true;

  isMobile = false;

  constructor(
    @Inject(API_URL) protected apiUrl: string,
    protected el: ElementRef,
    protected deviceDetector: DeviceDetectorService,
    protected miscSnackBarService: MiscSnackBarService,
    private http: HttpClient,
    private snackBar: MatSnackBar,
    protected renderer: Renderer2,
    protected changeDetectorRef: ChangeDetectorRef,
    protected dialog: MatDialog,
    protected qbService: QBService,
    protected customerService: CustomerService,
    protected projectService: ProjectService,
    @Inject(MAT_DIALOG_DATA) private data: number
  ) {
    this.projectId = data;

    this.isMobile = this.deviceDetector.isMobile();

  }

  ngOnInit(): void {

    if(this.isMobile) {
      this.fullScreen();
    }

    this.projectService.getProject(this.projectId).subscribe(proj => {

      this.project = proj
      this.projectName = this.project.name;

      if(this.project.customer) {
        this.customer = this.project.customer;
      }

      this.getInfo();
      this.getClassesAndServices();
      this.fillFiles();

      this.qbService.newInvoice$.subscribe(newInv => {
        if(newInv.id) {
          this.insertInvoice(newInv)
        }
      })


    })
  }

  fillFiles() {
    this.projectService.getProjectFiles(this.project.id).subscribe(files => this.project.files = files)
  }

  getClassesAndServices() {
    forkJoin([this.qbService.getQBClasses(), this.qbService.getQBServices()])
    .pipe(
      takeUntil(this.getUnsubFromAllSubs())
    )
    .subscribe(result => {
      const classes = (result[0] as unknown as QBClass[]).map(cls => {
        return {
          label: cls.fullyQualifiedName,
          value: cls.fullyQualifiedName
        } as SelectItem
      })

      const servs = (result[1] as unknown as QBServ[]).map(srv => {
        return {
          label: srv.fullyQualifiedName,
          value: srv.fullyQualifiedName
        } as SelectItem
      })

      this.baseQbServClasses = result;
      this.qbServClasses = [classes, servs];
    })
  }

  getInfo() {
    this.listToShow = [];
    this.copyList = [];

    this.nullifyMap();
    this.contentLoading = true;
    forkJoin([this.qbService.getSalesForProject(this.projectId), this.customerService.getQBCustomers()]).subscribe(result => {

      const sales = result[0];
      this.qbCustomers = result[1];
      this.payments = sales.payments;

      if(sales) {
        if(sales.estimates) {

          sales.estimates.forEach(sale => {
            sale.type = 'Estimate'
          })

          this.listToShow = this.listToShow.concat(sales.estimates);

          this.projectSales.estimates = sales.estimates;
          this.showEstimateButton = false;
        }
        if(sales.invoices) {
          this.listToShow = this.listToShow.concat(sales.invoices.map(sale => Object.assign(sale, {type: 'Invoice'})));
          this.projectSales.invoices = sales.invoices;
          this.updateTotalInfo();
        }
        if(sales.payments) {
          this.listToShow = this.listToShow.concat(sales.payments.map(sale => {
            this.paymentsMap.set(sale.id, sale);
            this.projectSales.payments = sales.payments;
            return Object.assign(sale, {type: 'Payment'})
          }));
        }

        this.listToShow.map(sale => {
          if(!sale.txnStatus) {
            if(sale.balance === 0) {
              Object.assign(sale, {
                txnStatus: 'Paid',
                statusNum: 100
              });

            } else if(sale.balance === sale.totalAmt) {
              Object.assign(sale, {
                txnStatus: 'Open',
                statusNum: 0
              })
            } else if(sale.type === 'Payment') {
              Object.assign(sale, {
                txnStatus: `Closed`,
                statusNum: 100
              })
            } else if(sale.balance >= 0 && sale.totalAmt >= 0) {
              const statusNum = 100 - (Math.round((sale.balance / sale.totalAmt) * 100));
              Object.assign(sale, {
                txnStatus: `Paid ${statusNum}%`,
                statusNum
              })
            }
          }

          if(sale.balance >= 0 && sale.totalAmt >= 0) {
            Object.assign(sale, {recievedPayments: sale.totalAmt - sale.balance})
          }

          if(sale.linkedTxn && sale.linkedTxn.length > 0) {
            const paymentsList = [];
            sale.linkedTxn.forEach(txn => {
              if(this.paymentsMap.has(txn.txnId)) {
                paymentsList.push(this.paymentsMap.get(txn.txnId))
              }
            })


            Object.assign(sale, {paymentsList})
          }
        })

        this.contentLoading = false;
        this.copyList = [...this.listToShow];


        this.sortByLabel('createTime');
        this.qbConnected = true;
      }
    }, error => {
      if(error.type === 'qb.QuickBookException') {
        this.qbConnected = false;
        this.openSnackBar(error.message)
      }
      this.contentLoading = false;
    })
  }

  nullifyMap() {
    this.sortMap.set('createTime', 0);
    this.sortMap.set('docNumber', 0);
    this.sortMap.set('dueDate', 0);
    this.sortMap.set('balance', 0);
    this.sortMap.set('totalAmt', 0);
    this.sortMap.set('jobName', 0);
    this.sortMap.set('txnStatus', 0);
  }

  onTabChanged(event: number[]) {
    this.activeIndex = event;
  }

  loadFiles(event) {
    this.fileLoading$.next(this.listToShow[event.index].id);
  }

  openSnackBar(message: string, duration = 5000) {
    this.snackBar.open(message, '', {
      duration,
      panelClass: 'error-snackbar',
      verticalPosition: 'top',
    });
  }

  countMap(param: string) {
    let num = this.sortMap.get(param);
    if(num === 1) {
      num++;
    } else if(num === 0) {
      this.nullifyMap();
      num++;
    } else if(num === 2) {
      num = 0;
    }

    this.sortMap.set(param, num);
  }

  sortByLabel(param: string) {
    if(!this.contentLoading) {
      this.activeIndex = [];

      this.countMap(param);
      let numm = 1;
      if(this.sortMap.get(param) === 2) numm = -1;
      if(this.sortMap.get(param) === 0) {
        this.listToShow = [...this.copyList];
        return
      }
      ;

      this.listToShow.sort((a, b) => {
        const oldDate = new Date('2017-01-01');

        if(param === 'createTime') {
          const bTime = (b.metaData.createTime ? b.metaData.createTime.getTime() : oldDate.getTime()) as number;
          const aTime = (a.metaData ? a.metaData.createTime.getTime() : oldDate.getTime()) as number;
          return (bTime - aTime) * numm;
        }
        if(param === 'txnStatus') {
          return (b.statusNum - a.statusNum) * numm;
        }
        if(param === 'dueDate') {
          const bTime = (b.dueDate ? b.dueDate.getTime() : oldDate.getTime()) as number;
          const aTime = (a.dueDate ? a.dueDate.getTime() : oldDate.getTime()) as number;

          return (bTime - aTime) * numm
        }

        if(param === 'jobName') {
          if(a.customField[1].name === 'Job Name') {
            if(a.customField[1].stringValue < b.customField[1].stringValue) {
              return -1 * numm;
            }
            if(a.customField[1].stringValue > b.customField[1].stringValue) {
              return 1 * numm;
            }
            return 0;
          }
        }

        return (b[param] - a[param]) * numm
      })
    }
  }

  openQB() {
    const windowReference = window.open();
    let baseLink = `https://app.qbo.intuit.com`;
    let link = ``;
    const customerName = encodeURIComponent(this.project.customer.name)

    if(environment.dev) {
      baseLink = `https://app.sandbox.qbo.intuit.com`
    }

    if(this.project.customer.qbId) {
      link = `${baseLink}/app/customerdetail?nameId=${this.project.customer.qbId}`
    } else {
      link = `${baseLink}/app/search?searchCat=transaction&searchTransactionType=x999&searchValue=&searchAdvFieldArray=name&searchAdvFieldLabelArray=Display%20Name&searchAdvValueArray=${customerName}&searchAdvValueLabelArray=${customerName}&searchAdvOpArray=~`
    }

    windowReference.location.assign(link);
  }

  connectToQb() {
    const dialogRef = this.dialog.open(QbCustomerLinkDialogComponent, {
      data: {
        customerName: this.project.customer.name,
        customerId: this.project.customer.id,
        qbId: null
      },
      panelClass: 'qb-link-dialog',
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if(typeof result !== 'undefined') {
        if(result !== 'close-button') {
          if((result as Customer).qbId) {
            this.project.customer.qbId = (result as Customer).qbId;
            this.project.customer.qbDisplayName = (result as Customer).qbDisplayName;
            this.qbConnected = true;
            this.getInfo();
          }
          // const fcust = this.customers.find(ccust => ccust.id === result.id);
          // if (fcust) {
          // 	fcust.qbId = result.qbId
          // 	fcust.qbDisplayName = result.qbDisplayName
          // }
        }
      }
    });
  }

  createEstimate() {
    this.estloadingSpinner = true;
    this.qbService.createEstimate(this.projectId, 0).subscribe(sale => {
      sale.type = 'Estimate'
      this.listToShow.unshift(sale)
      this.copyList.unshift(sale)

      this.activeIndex = [0];

      timer(500).subscribe(emit => {
        this.fileLoading$.next(sale.id);
      })


      this.showPdfFile = true;
      this.pdfHeader = 'Proposal';

      const url = this.apiUrl + `/project/${this.project.id}/files/last-proposal`;

      if(!this.deviceDetector.isMobile()) {
        this.showPdfByUrl(url)
      }

      this.estloadingSpinner = false;
      this.showEstimateButton = false;


    }, error => {
      this.estloadingSpinner = false;
      this.miscSnackBarService.openErrorSnackBar(error.message)
    })
  }

  createInvoice() {
    // this.openEstInv('Invoice')
    this.loadingSpinner = true;

    this.qbService.createInvoice(this.projectId, 0).subscribe(sale => {
      this.insertInvoice(sale)
      timer(500).subscribe(emit => {
        this.fileLoading$.next(sale.id);
      })
    }, error => {
      this.loadingSpinner = false;
    })
  }

  insertInvoice(sale: ProjectSale) {
    sale.type = 'Invoice';
    this.loadingSpinner = false;

    if(this.listToShow[0] && this.listToShow[0].type === 'Estimate') {
      this.listToShow.splice(1, 0, sale)
      this.copyList.splice(1, 0, sale)
      this.activeIndex = [1];
    } else {
      this.listToShow.unshift(sale)
      this.copyList.unshift(sale)
      this.activeIndex = [0];

    }
  }


  updateInvoice(sale: ProjectSale) {
    const fsale = this.listToShow.find(sl => sl.id === sale.id)
    fsale.dueDate = sale.dueDate;
    fsale.balance = sale.balance;
    fsale.totalAmt = sale.totalAmt;
    fsale.txnStatus = sale.txnStatus;

    const cfsale = this.copyList.find(sl => sl.id === sale.id)
    cfsale.dueDate = sale.dueDate;
    cfsale.balance = sale.balance;
    cfsale.totalAmt = sale.totalAmt;
    cfsale.txnStatus = sale.txnStatus;

    this.totalOpenedBalance = 0;
    this.overdueOpenedBalance = 0;

    this.updateTotalInfo();
  }

  updateTotalInfo() {
    this.projectSales.invoices.forEach(sale => {
      this.totalOpenedBalance += sale.balance;
      if(moment(sale.dueDate).diff(new Date(), 'days') < 0) {
        this.overdueOpenedBalance += sale.balance;
      }
    })
  }

  deleteInvEst(saleId: string) {

    const fsaleIndex = this.listToShow.findIndex(sl => sl.id === saleId)
    // const accordIndex = this.activeIndex.findIndex(id => id === fsaleIndex)

    if(this.listToShow[fsaleIndex].type === 'Estimate') {
      this.showEstimateButton = true;
    }


    if(fsaleIndex > -1) {
      this.listToShow.splice(fsaleIndex, 1);
      // this.activeIndex.splice(accordIndex, 1);
    }

    const fsaleId = this.copyList.findIndex(sl => sl.id === saleId)
    if(fsaleId > -1) {
      this.copyList.splice(fsaleId, 1);
    }

    this.activeIndex = [];

    this.updateTotalInfo();
  }

  showFile() {
    this.showPdfFile = true;
  }

  hideFile() {
    this.showPdfFile = false;

    const dialogHTML = document.getElementsByClassName('estimates-modal-dialog')[0]
    dialogHTML.classList.remove('double-view-dialog')

  }

  showPdfByUrl(url: string) {
    const dialogHTML = document.getElementsByClassName('estimates-modal-dialog')[0]
    dialogHTML.classList.add('double-view-dialog')

    this.downloadFile(url).subscribe(
      (res) => {
        this.pdfLoading = false;
        this.blobUrl = res;

        // this.pdfViewer.pdfSrc = res; // pdfSrc can be Blob or Uint8Array
        // this.pdfViewer.refresh(); // Ask pdf viewer to load/refresh pdf

      }, error => {
        this.pdfLoading = false;
        this.openSnackBar('Error! File not found.')
      }
    );
  }

  downloadPdf(file: QBFile) {
    this.pdfLoading = true;

    const fFile = this.project.files.find(tfile => tfile.name === file.fileName)

    if(fFile) {
      this.pdfHeader = file.fileName;

      const url = this.apiUrl + `/project/${this.project.id}/files/${fFile.id}`;

      if(!this.isMobile) {
        this.showPdfFile = true;

        this.showPdfByUrl(url)
      }

      if(this.isMobile) {
        this.openPdf(fFile.id)
      }
    } else {
      window.open(file.tempDownloadUri, '_blank');
    }

  }

  openPdf(fileId: number): void {
    const cpDialogRef = this.dialog.open(PdfPreviewDialogComponent, {
      data: {
        dialogHeader: this.project.name,
        link: '/project/' + this.project.id + '/files/' + fileId,
        showSendButton: true
      },
      panelClass: 'pdf-preview-dialog'
    });
  }


  private downloadFile(url: string): any {
    return this.http.get(url, {responseType: 'blob'})
    .pipe(
      map((result: any) => {
        return result;
      })
    );
  }

  createInvoiceDialog(sale: ProjectSale) {
    const dialogRef = this.dialog.open(CreateEstiinvDialogComponent, {
      data: {
        sale,
        projectId: this.projectId
      },
      panelClass: 'estinv-window-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  fullScreen() {
    (this.el.nativeElement as HTMLElement).parentElement.parentElement.classList.add('FULLSCREEN-DIALOG')
  }


  ngOnDestroy() {

  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }
}
